import DeviceDataGrid from './DeviceDataGrid';

export default DeviceDataGrid;
